import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "categories", "logo", "url", "images", "address", "defaultType"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { DEFAULT_SEO_TYPE } from './LocalBusinessSchema.constants';
import { getFirstIfArray, getSchemaGeneratorFunction, getTypeForCategory } from './LocalBusinessSchema.utils';
import { Helmet } from '../../../../modules/foundation/components/HelmetProvider';
import { BusinessCategoriesPropType } from '../../../../modules/foundation/types/category';
import { ImagePropType, ImagesPropType, LocationPropType } from '../../../../services/proptypes';
var defaultProps = {
  url: null,
  images: [],
  logo: null,
  address: null,
  defaultType: DEFAULT_SEO_TYPE
};
export default function LocalBusinessSchema(_ref) {
  var name = _ref.name,
    categories = _ref.categories,
    logo = _ref.logo,
    url = _ref.url,
    images = _ref.images,
    address = _ref.address,
    defaultType = _ref.defaultType,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _getFirstIfArray = getFirstIfArray(categories),
    category = _getFirstIfArray.category,
    subCategory = _getFirstIfArray.subCategory;
  var type = getTypeForCategory(category, {
    fallback: defaultType
  });
  var schemaGeneratorFunction = getSchemaGeneratorFunction(category);
  var schema = schemaGeneratorFunction(name, type, _objectSpread({
    url: url,
    images: images,
    logo: logo,
    address: address,
    subCategory: subCategory
  }, rest));
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(schema)));
}
LocalBusinessSchema.defaultProps = defaultProps;